<template>
  <div class="cart-breadcrumb">
    <ul class="cart-breadcrumb-list">
      <li class="cart-breadcrumb-element">
        <button class="cart-breadcrumb-button" :tabindex="currentStep > 0 ? 0 : -1" :class="{'is-active': currentStep > 0, 'is-current': currentStep === 0}" type="button" @click="onGoTo(0)">
          <i class="ico ico-check-alone" v-if="currentStep > 0"></i>
          <i class="cart-breadcrumb-step" v-else>1</i>
          {{ Translator('front.cart.steps.step_1')}}
        </button>
      </li>
      <li class="cart-breadcrumb-element">
        <button class="cart-breadcrumb-button" :tabindex="currentStep > 1 ? 0 : -1" :class="{'is-active': currentStep > 1, 'is-current': currentStep === 1}" type="button" @click="onGoTo(1)">
          <i class="ico ico-check-alone" v-if="currentStep > 1"></i>
          <i class="cart-breadcrumb-step" v-else>2</i>
          {{ Translator('front.cart.steps.step_2')}}
        </button>
      </li>
      <li class="cart-breadcrumb-element">
        <button class="cart-breadcrumb-button" :tabindex="currentStep > 2 ? 0 : -1" :class="{'is-active': currentStep > 2, 'is-current': currentStep === 2}" type="button" @click="onGoTo(2)">
          <i class="ico ico-check-alone" v-if="currentStep > 2"></i>
          <i class="cart-breadcrumb-step" v-else>3</i>
          {{ Translator('front.cart.steps.step_3')}}
        </button>
      </li>
      <li class="cart-breadcrumb-element">
        <button class="cart-breadcrumb-button" :tabindex="currentStep > 3 ? 0 : -1" :class="{'is-active': currentStep > 3, 'is-current': currentStep === 3}" type="button" @click="onGoTo(3)">
          <i class="ico ico-check-alone" v-if="currentStep > 3"></i>
          <i class="cart-breadcrumb-step" v-else>4</i>
          {{ Translator('front.cart.steps.step_4')}}
        </button>
      </li>
    </ul>
  </div>
</template>
<style scoped lang="scss">
.cart-breadcrumb {
  margin-bottom: rem(30);
  @media(max-width: 599px) {
    display: none;
  }
  .cart-breadcrumb-list {
    @include resetList;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cart-breadcrumb-element {
    white-space: nowrap;
    &:not(:first-child)::before {
      content: '';
      position: relative;
      display: inline-block;
      width: rem(20);
      height: rem(1);
      background-color: $blue-udark;
      margin-left: rem(15);
      margin-right: rem(15);
      vertical-align: middle;
      top: rem(27);
      @include tablet {
        top: auto;
      }
      @include desktop {
        top: rem(27);
      }
      @include desktop-xl {
        top: auto;
      }
    }
  }
  .cart-breadcrumb-button {
    @include resetBtn;
    font-weight: 400;
    color: $blue-udark;
    &[tabindex="-1"] {
      cursor: default;
    }
    &.is-active {
      .ico,
      .cart-breadcrumb-step {
        display: block;
        margin-left: auto;
        margin-right: auto;
        @include tablet {
          display: inline-block;
          margin-right: rem(10);
        }
        @include desktop {
          display: block;
          margin-left: auto;
          margin-right: auto;
        }
        @include desktop-xl {
          display: inline-block;
          margin-right: rem(10);
        }
      }
      .ico {
        width: rem(28);
        height: rem(28);
        font-size: rem(14);
        line-height: rem(24);
        background-color: $blue-udark;
        color: $white;
        vertical-align: middle;
        font-size: rem(20);
        line-height: rem(26);
        border-radius: 100%;
      }
    }
  }
  .ico,
  .cart-breadcrumb-step {
    position: relative;
    border-radius: 100%;
    color: $blue-udark;
    border: rem(2) solid $blue-udark;
    font-weight: 600;
    width: rem(28);
    height: rem(28);
    font-size: rem(14);
    line-height: rem(24);
    text-align: center;
    margin-right: rem(10);
    font-style: normal;
    display: block;
    margin-left: auto;
    margin-right: auto;
    @include tablet {
      display: inline-block;
      vertical-align: middle;
      margin-right: rem(10);
    }
    @include desktop {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    @include desktop-xl {
      display: inline-block;
      margin-right: rem(10);
    }
  }
}
</style>
<script>
import AppControlService from '@/services/AppControl';

export default {
  name: 'breadcrumb',
  components: {},
  data () {
    return {
      currentStep: AppControlService.currentStep
    }
  },
  created() {
    this._onChangeStep = this._onChangeStep.bind(this);
    AppControlService.on('step', this._onChangeStep);
  },
  beforeDestroy() {
    AppControlService.off('step', this._onChangeStep);
  },
  mounted() {},
  methods: {
    onGoTo(step) {
      if(step < this.currentStep) AppControlService.goTo(step);
    },

    _onChangeStep(step) {
      this.currentStep = step;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
